module.exports = __webpack_public_path__ + "static/img/gaozhonglishi3.e07e0c75.jpg";